import { BusinessRole } from "fe-shared/src/types/domain";

// useRecycleMaterials keys its cache on these roles - a second array means a second fetch.
export const MATERIAL_ROLES = [
  BusinessRole.Hauler,
  BusinessRole.Collector,
  BusinessRole.Processor,
  BusinessRole.OneTimePickup,
];

// Matches the transaction flag banner, which is the pattern this one mirrors.
export const FLAG_COLOR = "#E64040";
